module.exports = __webpack_public_path__ + "img/移动.1c5bf407.svg";